import { theme as theme2 } from '@clubspark-react/ui';

import { makeStyles } from 'makeStyles';
import { BACKGROUND_GREY, LIGHT_BLUE2, WHITE } from 'theme/colors';

export const useStyles = makeStyles()((theme) => ({
  overlay: {
    backgroundColor: BACKGROUND_GREY,
    padding: 0,
  },
  dialogTitle: {
    backgroundColor: WHITE,
    padding: '1rem 1.5rem 1rem 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '2rem',
    zIndex: 1,
  },
  noMarginBottom: {
    marginBottom: 0,
  },
  borderBottom: {
    borderBottom: `1px solid ${theme2.colors.coreGreys10.value}`,
  },
  overlayTitle: {
    fontSize: 24,
    fontWeight: 600,
  },
  closeIcon: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  contentContainer: {
    backgroundColor: theme.palette.common.white,
    borderRadius: 3,
    paddingBottom: 20,
    paddingTop: 20,
  },
  dialogActions: {
    marginTop: 15,
    gap: 10,
    padding: '16px 24px',
    background: WHITE,
  },
  overlayWrapper: {
    padding: 0,
  },
  playerLink: {
    '& a': {
      fontSize: '1.5rem',
    },
  },
  score: {
    borderRadius: 5,
    fontWeight: 600,
  },
  select: {
    color: LIGHT_BLUE2,
    padding: theme2.space.md.value,
    fontSize: theme2.fontSizes.semiMedium.value,
    '&:hover': {
      textDecoration: 'underline',
      textUnderlineOffset: '2px',
    },
  },
  backButton: {
    marginLeft: 5,
    color: LIGHT_BLUE2,
    '&:hover': {
      textDecoration: 'underline',
      textDecorationThickness: 1,
      textUnderlineOffset: 3,
    },
  },
  formContainer: {
    border: `1px solid ${theme2.colors.coreGreys20.value}`,
  },
  formHeader: {
    backgroundColor: theme2.colors.coreGreys5.value,
    border: `1px solid ${theme2.colors.coreGreys20.value}`,
  },
  colorBlue: {
    color: LIGHT_BLUE2,
  },
  colorBlack: {
    color: theme2.colors.coreGreys100.value,
  },
}));
